var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-tag',{staticClass:"tag",attrs:{"type":"success","size":"large"}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('van-icon',{staticClass:"delete",attrs:{"name":"cross"},on:{"click":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }